module.exports = __webpack_public_path__ + "media/images/landing/en/main-3e652da31db94ab0ddc13b9334dd3f5d.webp";